import { CheckIcon } from "@heroicons/react/24/outline"

export default function PersonalizedVisual({ items }: { items: string[] }) {
  return (
    <div className="vm-card w-full divide-y divide-vm-line">
      {items.map((item, index) => (
        <div
          className="flex animate-fade-up items-center gap-3 px-4 py-4"
          key={item}
          style={{ animationDelay: `${200 + index * 220}ms` }}
        >
          <span
            className="flex h-7 w-7 shrink-0 animate-check-pop items-center justify-center rounded-full bg-vm-green-solid text-white"
            style={{ animationDelay: `${400 + index * 220}ms` }}
          >
            <CheckIcon className="h-4 w-4" />
          </span>
          <span className="text-base font-medium text-vm-ink">{item}</span>
        </div>
      ))}
    </div>
  )
}
